<template>
  <v-container 
    fluid
    class="d-flex flex-column"
  >
    <v-container
      fluid
      class="d-flex flex-row-reverse pa-0"
    >
      <close-button />
    </v-container>

    <reset-password v-if="auth.token_login" />
  
    <v-container
      v-if="!auth.token_login"
      fluid
    >
      <v-btn-toggle
        v-model="mode"
        mandatory
        rounded
      >
        <v-btn 
          v-for="tab in tabs"
          :key="tab.value"
          :value="tab.value"
        >
          <v-icon>{{ tab.icon }}</v-icon>
        </v-btn>
      </v-btn-toggle>

      <v-tabs-items
        v-model="mode"
        light
      >
        <v-tab-item
          v-for="tab in tabs"
          :key="tab.value"
          :value="tab.value"
        >
          <component
            :is="tab.componentName"
            :ref="tab.ref"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </v-container>
</template>

<script>
import ChangePassword from './password/ChangePassword.vue'
import ResetPassword from './password/ResetPassword'
import PaymentMethods from '../../../stripe/PaymentMethods'
import Subscriptions from '../../../stripe/subscriptions/Index'
import CloseButton from '../CloseButton'

export default {
  name: 'AccountProfile',
  components:{ ResetPassword, ChangePassword, PaymentMethods, Subscriptions, CloseButton },
  props: {
    stripeOptions: {
      type: Object,
      default: ()=>{return {}}
    },
    userSlot: {
      type: Object,
      default: ()=>{return null}
    }
  },
  data(){
    return {
      mode: 'password',
      tabData: {
        password: {
          icon: 'mdi-lock',
          componentName: 'ChangePassword'
        },
        paymentMethods: {
          icon: 'mdi-credit-card-multiple',
          componentName: 'PaymentMethods'
        },
        subscriptions: {
          icon: 'mdi-sync',
          ref: 'subscriptions',
          componentName: 'Subscriptions'
        },
      }
    }
  },
  computed: {
    tabs() {
      const sOpt = this.stripeOptions
      const tabs = [this.tabData.password]
      if(!sOpt.hide_all) {
        if (!sOpt.hide_payment_methods) {
          tabs.push(this.tabData.paymentMethods)
        }
        if (!sOpt.hide_subscriptions) {
          tabs.push(this.tabData.subscriptions)
        }
      }
      if (this.userSlot && this.userSlot.componentName) {
        tabs.push(this.userSlot)
      }
      return tabs
    }
  },
  watch:{
    mode(v){
      if (v && this.$refs[v]) {
        this.$refs[v].fetch()
      }
    }
  },
}
</script>